import { defaultsDeep, cloneDeep } from 'lodash'
import { Role } from '../models/role.entity'

// Initial states

const ROLE_INITIAL_STATE: Partial<Role> = {
  code: undefined,
  label: undefined,
}

/**
 * Initialize a partial role
 * @param role - the partial role
 * @returns the role updated
 */
export function initRole(role: Partial<Role> = {}): Role {
  return defaultsDeep(cloneDeep(role), ROLE_INITIAL_STATE)
}
